import { useMouseEventCallback } from '@client/hooks/use-events.hooks';
import { useProjectState } from '@client/store/project';
import { ProjectFolderId } from '@shared/models/folder.model';
import { IProjectInfo } from '@shared/models/project.model';
import React from 'react';
import { useEditProjectDialogStore } from '../../EditProject/edit-project.store';
import { IconButton } from '@ui/buttons';
import { Menu } from '@ui/menus/Menu';
import { useOpenPaywallDialog } from '@features/projects/Paywall/paywall.hook';

interface TemplateProjectItemProps {
  item: IProjectInfo;
  folderId?: ProjectFolderId;
  onClick?: () => void;
}

export const TemplateProjectItem: React.FC<TemplateProjectItemProps> = ({
  item,
  folderId,
  onClick,
}) => {
  const { set } = useEditProjectDialogStore();
  const { isBehindPaywall: shouldOpenPaywallDialog, openPaywallDialog } =
    useOpenPaywallDialog();

  const { isCreating } = useProjectState('isCreating');
  const itemId = Number(item.id);

  const openCreateDialog = () => {
    if (shouldOpenPaywallDialog('create-project')) {
      openPaywallDialog('create-project');
      return;
    }
    set({ type: 'project', mode: 'create', id: itemId, folderId });
    onClick?.();
  };

  const openEditDialog = useMouseEventCallback(() => {
    set({ type: 'template', mode: 'edit', id: itemId });
    onClick?.();
  });

  return (
    <Menu.Item onClick={openCreateDialog} disabled={isCreating}>
      {item.name}
      <Menu.Item.Action>
        <IconButton category="mui" icon="Edit" onClick={openEditDialog} />
      </Menu.Item.Action>
    </Menu.Item>
  );
};
